import { defineFeature } from "../../app/feature";
import { SourcesIntakePage } from "./SourcesIntakePage";
import { SourcesInventoryPage } from "./SourcesInventoryPage";

/** Corpus intake: files, folders, ZIP packages, manifests (task 4020.2), and the corpus
 * inventory (task 4020.8). Owned by the evidence-vault lane. */
export default defineFeature({
  id: "sources",
  title: "Source intake",
  routes: [
    { path: "/sources", Component: SourcesIntakePage },
    { path: "/sources/inventory", Component: SourcesInventoryPage },
  ],
  nav: { label: "Intake", path: "/sources", section: "Sources", order: 10 },
  // The feature contract has one permission set for all routes. Read-only roles may open the
  // inventory; every intake action is still authorized by the API (engagement.manage).
  permissions: ["engagement.manage", "engagement.read"],
});
